<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500px"
    scrollable
    @keydown.esc="dialog = false"
  >
    <v-card :loading="loading" :disabled="loading">
      <card-title large closeable @click:close="dialog = false">
        Изменение пароля
      </card-title>
      <card-content>
        <validation-observer ref="validator">
          <v-row dense>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                name="Старый пароль"
                rules="required"
              >
                <v-text-field
                  id="form-text-field-old-password"
                  v-model="passwordData.old_password"
                  counter
                  outlined
                  dense
                  maxlength="50"
                  :append-icon="visiblePasswordOld ? 'mdi-eye-off' : 'mdi-eye'"
                  label="Старый пароль"
                  placeholder="Введите старый пароль"
                  :type="visiblePasswordOld ? 'text' : 'password'"
                  :error-messages="errors"
                  @click:append="visiblePasswordOld = !visiblePasswordOld"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                vid="password_vid"
                name="Новый пароль"
                rules="required|strong_password"
              >
                <v-text-field
                  id="form-text-field-new-password"
                  v-model="passwordData.new_password"
                  counter
                  outlined
                  dense
                  maxlength="50"
                  :append-icon="visiblePasswordNew ? 'mdi-eye-off' : 'mdi-eye'"
                  :error-messages="errors"
                  label="Новый пароль"
                  placeholder="Введите новый пароль"
                  :type="visiblePasswordNew ? 'text' : 'password'"
                  @click:append="visiblePasswordNew = !visiblePasswordNew"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col v-if="!visiblePasswordNew">
              <validation-provider
                v-slot="{ errors }"
                mode="eager"
                name="Подтверждение пароля"
                :rules="{
                  required: true,
                  confirmed: { target: 'password_vid' }
                }"
              >
                <v-text-field
                  id="form-text-field-new-password-confirmation"
                  v-model="passwordData.new_password_confirmation"
                  counter
                  outlined
                  dense
                  maxlength="50"
                  :error-messages="errors"
                  label="Подтверждение пароля"
                  placeholder="Подтвердите новый пароль"
                  type="password"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </validation-observer>
      </card-content>

      <card-actions>
        <v-spacer />
        <v-btn
          id="form-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="dialog = false"
        >
          Отменить
        </v-btn>
        <v-btn
          id="form-btn-save"
          color="primary"
          depressed
          @click="changePassword()"
        >
          Сохранить
        </v-btn>
      </card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import NotificationMixin from "@/mixins/NotificationMixin";
import Repository from "@/api/profile";

const passwordFactory = () => ({
  old_password: "",
  new_password: "",
  new_password_confirmation: ""
});

export default {
  mixins: [NotificationMixin],

  model: {
    prop: "open",
    event: "change"
  },

  props: {
    open: Boolean
  },

  data() {
    return {
      loading: false,
      passwordData: passwordFactory(),
      visiblePasswordOld: false,
      visiblePasswordNew: false
    };
  },

  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("change", value);
      }
    }
  },

  watch: {
    open(newVal) {
      if (!newVal) {
        this.resetForm();
        this.$emit("close");
      }
    }
  },

  methods: {
    async changePassword() {
      if (!(await this.$refs.validator.validate())) return false;

      const passwordData = { ...this.passwordData };
      if (this.visiblePasswordNew) {
        passwordData.new_password_confirmation = passwordData.new_password;
      }

      this.loading = true;

      try {
        const { data } = await Repository.changePassword(passwordData);
        this.sendAlert(data.alert);

        this.$store.dispatch("fetchProfile");
        this.$emit("update");

        this.dialog = false;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.passwordData = passwordFactory();
      this.$refs.validator.reset();
    }
  }
};
</script>
